// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1ZN7G","tab":"Tabs_tab__gzCcd","tabActive":"Tabs_tabActive__2otSw"};